import React, { useEffect, useState } from "react";
import ClientProfileServices from "../clientProfileServices";

export default function Logo_Template(param: any) {
    global.portalLogo = '/assets/images/logos.png';

    const [logo, setLogo] = useState<any>([]);
    const [selectedFile, setSelectedFile] = useState<any>(null);
    const [logoSaved, setLogoSaved] = useState(false);

    useEffect(() => {
        console.log(param)
        ClientProfileServices.getClientImage().then((res) => {
            setLogo(res)
            global.portalLogo = res;
        })
    }, [param]);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files && event.target.files[0];
        if (file) {
            setSelectedFile(file);
            setLogo(URL.createObjectURL(file));
        }
        console.log(logo);
        console.log(selectedFile);
        global.portalLogo = logo;
    };

    const handleSave = async () => {

        if (selectedFile) {

            // Upload the logo
            const uploadResponse = await ClientProfileServices.uploadLogo(selectedFile);

            if (uploadResponse) {

                const saveResponse = await ClientProfileServices.saveClientLogo(uploadResponse.data);

                if (saveResponse) {

                    setLogoSaved(true);

                    setTimeout(() => {
                        setLogoSaved(false);
                    }, 3000);
                }

                else {
                    console.error("Failed to save client logo data");
                }
            } else {
                console.error("Logo upload failed");
            }
        }
    };

    return (
        <div className="box box-add-region">

            <div className="box-header well">
                <h2>Upload Logo</h2>
            </div>

            <div className="box-content form-box">

                {logoSaved && (
                    <div className="alert alert-info">
                        Logo has been uploaded successfully
                    </div>
                )}

                <div className="box mtl pLarge">
                    <div className="ws-3 pLarge">
                        <h1 className="text-xl ws-12 mbl mtxxl ptxl">Upload Logo</h1>
                        <div className="ws-12 grey pbl mtl">We recommend 500px x 500px minimum file size  Only .png files accepted</div>
                    </div>

                    <div className="ws-9">

                        <div className="ws-12 pm">
                            <div className="ws-6">
                                <label className=" text-center pull-left">
                                    {<img alt="Korrect"  src={logo} className="icon-user1 paleTurquoise positionRelative pLarge mtl mbl width200 height200"/>}

                                </label>

                                <div className="pull-left mtxl ptl mll">
                                    <div className="pull-left mtxl ptxl mll">
                                        <label className="mtxl btn-search pLarge ptl pbl" >
                                            <input type="file" accept="image/*" className="hide" onChange={handleFileChange} />  Select Image
                                        </label>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </div>

            <div className="box-footer pull-right">
                <a className="icon-btn edit btn-sm" onClick={handleSave}>
                    <i className="icon-save"></i> Save</a>
            </div>
        </div>


    )

}